// utils/employeeUtils.js
import axios from 'axios';
import { APIBrancheNames, APICounterNames, APIEmployeeNames, APIPositionNames, APIShiftTypeNames, APISupplierNames } from '../services/APIs';
import { getUserDetails } from './helpers';

// const branchId = getUserDetails("branchId");
const params = {branch_id: getUserDetails("branchId")};

export const fetchBranchs = async () => {
    try {
        const response = await axios.get(APIBrancheNames);
        if (response.data.status === 'success') {
            return response.data.data || [];
        } else {
            throw new Error(response.data.message || "Failed to fetch branches");
        }
    } catch (error) {
        throw error;
    }
};


export const fetchEmployees = async () => {
    try {
        const response = await axios.get(APIEmployeeNames, { params });
        if (response.data.status === 'success') {
            return response.data.data || [];
        } else {
            throw new Error(response.data.message || "Failed to fetch employees");
        }
    } catch (error) {
        throw error;
    }
};
export const fetchPositions = async () => {
    try {
        const response = await axios.get(APIPositionNames, { params });
        if (response.data.status === 'success') {
            return response.data.data || [];
        } else {
            throw new Error(response.data.message || "Failed to fetch positions");
        }
    } catch (error) {
        throw error;
    }
};

export const fetchShitTypes = async () => {
    try {
        const response = await axios.get(APIShiftTypeNames, { params });
        if (response.data.status === 'success') {
            return response.data.data || [];
        } else {
            throw new Error(response.data.message || "Failed to fetch positions");
        }
    } catch (error) {
        throw error;
    }
};

export const fetchCounters = async () => {
    try {
        const response = await axios.get(APICounterNames, { params });
        if (response.data.status === 'success') {
            return response.data.data || [];
        } else {
            throw new Error(response.data.message || "Failed to fetch counters");
        }
    } catch (error) {
        throw error;
    }
};

export const fetchSuppliers = async () => {
    try {
        const response = await axios.get(APISupplierNames, { params });
        if (response.data.status === 'success') {
            return response.data.data || [];
        } else {
            throw new Error(response.data.message || "Failed to fetch supplier");
        }
    } catch (error) {
        throw error;
    }
};